import qaDevAccounts from "./qa-dev-accounts.json";
import { normalizeEmail, type AuthRole } from "./auth";

export type DevShortcut = {
  email: string;
  given: string;
  family: string;
  role: AuthRole;
};

/** Mock student ids shown as one-click dev sign-ins on localhost only. */
export const LOCAL_DEV_STUDENT_IDS = ["amy", "ann", "ben"] as const;

type QaDevAccount = {
  email: string;
  given: string;
  family: string;
  role: AuthRole;
  phone?: string;
};

/** Fixed list for local dev — synced with scripts/qa-dev-accounts.json and QA auth seed. */
export function localDevShortcuts(): DevShortcut[] {
  return (qaDevAccounts as QaDevAccount[]).map((item) => ({
    email: item.email,
    given: item.given,
    family: item.family,
    role: item.role,
  }));
}

export function localDevShortcutsForRole(role: AuthRole): DevShortcut[] {
  return localDevShortcuts().filter((item) => item.role === role);
}

export function isLocalDevShortcutEmail(email: string): boolean {
  const key = normalizeEmail(email);
  return localDevShortcuts().some((item) => normalizeEmail(item.email) === key);
}

/** Phone on file for seeded QA dev parents (when auth metadata is empty). */
export function devShortcutParentPhone(email: string): string {
  const key = normalizeEmail(email);
  const row = (qaDevAccounts as QaDevAccount[]).find(
    (item) => normalizeEmail(item.email) === key,
  );
  return row?.phone?.trim() ?? "";
}
